const INVALID_FILENAME_CHARS = /[<>:"/\\|?*\u0000-\u001f]/g;
const MAX_FILENAME_LENGTH = 180;

function sanitize(value: string): string {
  return value
    .replace(INVALID_FILENAME_CHARS, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/[. ]+$/g, "");
}

export function engineeringDocumentDownloadFilename(input: {
  skus: readonly string[];
  revision: string;
  status: string;
  documentTypeAbbreviation: string | null;
  title: string;
  originalFilename: string;
}): string {
  const skuPart =
    [...new Set(input.skus.map((sku) => sanitize(sku)).filter((sku) => sku !== ""))]
      .sort((left, right) => left.localeCompare(right))
      .join("+") || "nosku";
  const revision = sanitize(input.revision) || "norev";
  const status = sanitize(input.status) || "nostatus";
  const abbreviation = sanitize(input.documentTypeAbbreviation ?? "") || "DOC";
  const title = sanitize(input.title) || "document";
  const base = input.originalFilename.replace(/^.*[/\\]/, "");
  const dot = base.lastIndexOf(".");
  const extension = dot > 0 ? sanitize(base.slice(dot + 1)).replace(/ /g, "") : "";
  const suffix = extension === "" ? "" : `.${extension}`;
  const head = `${skuPart}.${revision}_${status}_${abbreviation}_`;
  const room = Math.max(1, MAX_FILENAME_LENGTH - head.length - suffix.length);
  const trimmedTitle = title.length > room ? title.slice(0, room).trim().replace(/[. ]+$/g, "") : title;
  return `${head}${trimmedTitle || "document"}${suffix}`;
}
